import { Component, ViewChild, TemplateRef, ElementRef, ViewEncapsulation, Renderer2, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { PaginationService } from 'src/app/PaginationService';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { AuService } from '../au.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { EditorComponent } from 'src/app/editor/editor.component';
import { AddMapCapaComponent } from '../../add-map-capa/add-map-capa.component';
import { MatSelect } from '@angular/material/select';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { firstValueFrom } from 'rxjs';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-au-findings',
  templateUrl: './au-findings.component.html',
  styleUrls: ['./au-findings.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AuFindingsComponent implements OnInit, OnDestroy, AfterViewInit {
  infoIconSrc: string = 'src/assets/img/info-yellow.png';
  //infoIconSrc1:string = '../../assets/img/info-yellow.png';
  isProcessing = true;
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  findingsData: any = {};
  severityTxt: any;
  assignedToUserTxt: any;
  assignedToDepartmentTxt: any;
  capaGroupTxt: any;
  departmentCodeTxt: any;

  isSeverityOdd: any = null;
  isassignedToUserOdd: any = null;
  isassignedToDepartmentOdd: any = null;
  closureDateDisableFlag: boolean = false;
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar, public message: messageService,
    private readonly elem: ElementRef, public qmsservice: qmsService, public paginationService: PaginationService, public auService: AuService,
    private readonly sanitizer: DomSanitizer, private readonly renderer: Renderer2) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  };

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value); requiredElement?.focus();
    }, 0)
  };

  requestedAtList: any = [];
  businessAreaList: any = [];
  requestedAtDropdown: any = [];
  businessAreaDropdown: any = [];
  selectedBusinessArea: any = [];
  requestedAtSearchText: string = '';
  businessAreaSearchText: string = '';

  selectedSeverity: any = null;
  selectedAssignedToUser: any = null;
  selectedResponseReviewUser: any = null;
  selectedImplementationReviewerUser: any = null;
  selectedAssignedToDepartment: any = null;
  selectedCapaGroup: any = null;

  dropDownForSeverity: any = [];
  dropDownForAssignedToUser: any = [];
  dropDownForDepartmentCode: any = [];
  dropDownForCapaGroup: any = [];

  severityDropdown: any = [];
  assignedToUserDropDown: any = [];
  departmentCodeDropdown: any = [];
  capaGroupDropDown: any = [];
  showFindingAddBtn: boolean = false;
  tempauditStatus: boolean;

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    this.qmsservice.auFindingsList = [];
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);
    this.message.isfindingsFrom = "AUF";
    this.getcallMethod();
    this.qmsservice.activity.status = this.qmsservice.activity.status ?? this.tempauditStatus;
    if ((this.qmsservice.activity.status == 'Received Q&A Response' || this.qmsservice.activity.status == 'In Progress/Received Q&A Response'
      || this.qmsservice.activity.status == 'In Progress' || this.qmsservice.activity.status == 'Peer Review Rejected'
      || this.qmsservice.activity.status == 'Peer Reviewer Requested More Info.'
      || this.qmsservice.activity.status == 'Closure Approver Requested More Info.' || this.qmsservice.activity.status == 'Closure Reviewer Requested More Info.'
      || this.qmsservice.activity.status == 'Closure Review Rejected' || this.qmsservice.activity.status == 'Closure Approve Rejected'
      || this.qmsservice.activity.status == 'Closure Approval Rejected') && this.auService.isAuditor) {
      this.showFindingAddBtn = true;
    } else {
      this.showFindingAddBtn = false;
    }

    const activityId = this.message.activityId;

    this.appService.getGroupsModuleCurrentUserVw("CAPA").subscribe((data: any) => {
      this.dropDownForCapaGroup = data;
      this.selectBoxForCapaGroup();
    });

    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');
    this.selectBoxForDepartmentCode();

    this.appService.getCodeListsByGroup("SEVERITY").subscribe((data: any) => {
      this.dropDownForSeverity = data;
      this.selectBoxForSeverity();
    });
    this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Response Reviewer').subscribe((data: any) => {
      this.responseReviewUserList = data;
      this.selectResponseReview();
    });
    this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Implementation Reviewer').subscribe((data: any) => {
      this.implementationReviewerUserList = data;
      this.selectImplementationReviewer();
    });
    this.appService.getAuParticipantsByAuNo(activityId).subscribe((data: any) => {
      this.dropDownForAssignedToUser = data;
      this.selectBoxForResponsibilityUserList();
      this.isProcessing = false;
    });

    this.appService.getQmsBusinessAreasByModule(this.qmsservice.moduleName).subscribe((businessArea: any) => {
      this.requestedAtList = businessArea ?? [];
      this.requestedAtList && this.selectBoxForRequestedAt();
    })
  }

  limitCharacters(event: Event, field: any) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    let charLimit: any = null;

    const fieldMapping: Record<number, string[]> = {
      4000: ['BUSINESS_AREA']
    };

    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = Number(limit);
        break;
      }
    }

    if (textLength > charLimit) {
      this.showSnackBar("Maximum " + charLimit + " Characters!", 'E');
      target.value = target.value.substring(0, charLimit);
    }
  }

  private selectBoxForRequestedAt(): void {
    this.requestedAtDropdown = this.requestedAtList?.filter((x: any) => x.module == 'AU')?.map((item: any) => ({
      valueExp: item.taskRequestedAt,
      displayExp: item.taskRequestedAt
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  public onRequestedAtSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('requested-at', item);

      if (item) {

        this.findingsData.requestedAtName = item.displayExp;
        const getBusinessArea = this.requestedAtList?.find((x: any) => x.taskRequestedAt == item.displayExp);
        [this.businessAreaList, this.selectedBusinessArea, this.findingsData.coreBusinessAreaName] = [[], [], null];
        this.businessAreaList = getBusinessArea?.listOfBusinessArea?.split(',');
        this.selectBoxForBusinessArea();

      } else {

        this.businessAreaList = [];
        this.businessAreaDropdown = [];
        this.findingsData.requestedAtName = '';
      }
    }
  }

  private selectBoxForBusinessArea(): void {
    this.businessAreaDropdown = this.businessAreaList?.map((bArea: any) => ({
      valueExp: bArea,
      displayExp: bArea
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  isAllBusinessAreaSelected?: boolean = false
  public onBusinessAreaSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation('business-area', this.selectedBusinessArea)
        this.isAllBusinessAreaSelected = this.businessAreaDropdown.length == this.selectedBusinessArea.length;
      });
  }

  @ViewChild('businessArea') businessArea: MatSelect;
  public toggleAllBusinessArea(): void {
    if (this.isAllBusinessAreaSelected) {
      for (const item of this.businessArea.options) item.select();
    } else {
      for (const item of this.businessArea.options) item.deselect();
      this.selectedBusinessArea = [];
    }

    setTimeout(() => { this.handleDropDownValidation('business-area', this.selectedBusinessArea); });
  }

  public getTooltip(): string {
    return this.selectedBusinessArea.join(',');
  }

  selectBoxForCapaGroup() {
    this.capaGroupDropDown = this.dropDownForCapaGroup?.map((item: any) => ({
      valueExp: item.groupId,
      displayExp: item.groupName
    }));
  }

  selectBoxForDepartmentCode() {
    this.departmentCodeDropdown = this.dropDownForDepartmentCode?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  selectBoxForSeverity() {
    this.severityDropdown = this.dropDownForSeverity?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  onSeveritySelect(event: any, item: any) {
    const groupId = this.qmsservice.selectedActivityGroupId;
    const groupDetailId = this.qmsservice.selectedGroupDetailData.groupDetailId;
    if (event.isUserInput) {
      this.handleDropDownValidation('severity-validation', item.valueExp);

      this.appService.getTypeSettingsByGrpIdGrpDetailId(groupId, groupDetailId).subscribe((response: any) => {
        for (const element of response) {
          if (element.type == ("Findings-" + item.displayExp)) {
            if (element.toBeClosedInDays) {
              this.findingsData.expectedClosureDate = null;
              this.closureDateDisableFlag = true;
            } else {
              this.closureDateDisableFlag = false;
            }
          }
        }
      });
    }
  }

  onSeverityDeSelect() {
    this.handleDropDownValidation('severity-validation', null);
  }

  selectBoxForResponsibilityUserList() {
    this.assignedToUserDropDown = this.dropDownForAssignedToUser?.filter((item: any) => item.applicationUserId !== null)
      ?.map((item: any) => ({
        valueExp: item.applicationUserId,
        displayExp: item.userName
      }));
  }

  onAssignToUserSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('assign-to-user-validation', item.valueExp);
    }
  }

  onAssignToUserDeSelect() {
    this.handleDropDownValidation('assign-to-user-validation', null);
  }

  responseReviewUserList: any = [];
  responseReviewDropdown: any = [];
  selectResponseReview() {
    this.responseReviewDropdown = this.responseReviewUserList?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    }));
  }

  implementationReviewerUserList: any = [];
  implementationReviewerDropdown: any = [];
  selectImplementationReviewer() {
    this.implementationReviewerDropdown = this.implementationReviewerUserList?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    }));
  }

  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('capaPopup', { static: true }) capaPopup: TemplateRef<any>;
  visibleCapaPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;
  @ViewChild('searchCapaRequired', { static: true }) searchCapaRequired: TemplateRef<any>;
  visibleSearchCapaRequiredPopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    height: 'auto',
    position: { left: '105px', top: '5px' },
    maxWidth: '90vw',
  };

  capaPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    minDate: new Date()
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  editorValue: string = '';
  public openEditor(value: string): void {

    const editorTitleMapping: Record<string, any> = {
      'Finding': this.dynamicLabel?.['FINDING']?.fieldName,
      'Reference': this.dynamicLabel?.['REFERENCE']?.fieldName,
      'Deliverables': this.dynamicLabel?.['DELIVERABLES']?.fieldName,
      'Auditor Comments': this.dynamicLabel?.['AUDITOR_COMMENTS']?.fieldName,
      'Assigned To User Details': this.dynamicLabel?.['ASSIGNED_TO_USER_DETAILS']?.fieldName,
    };

    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.findingsData[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.findingsData[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };


  config: EditorConfig = {
    buttons: [],
  };

  config1: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  popupTitle: any;
  visibleEditButton: boolean;
  operationFlag: any;
  openAddPopup() {
    this.tempauditStatus = this.qmsservice.activity.status;
    this.operationFlag = 'ADD';
    this.popupTitle = "Create Audit Findings";
    this.selectedTabName = "Create CAPA";
    this.visibleEditButton = true;
    this.buttonList = ["Save", "Cancel"];
    [
      this.findingsData.finding,
      this.findingsData.reference,
      this.findingsData.deliverables,
      this.findingsData.auditorComments,
      this.findingsData.assignedToUserDetails,
      this.findingsData.findingShortDescription,
      this.findingsData.capaDetails
    ] = new Array(6).fill("");

    [
      this.selectedResponseReviewUser,
      this.selectedImplementationReviewerUser,
    ] = new Array(3).fill(null);

    this.findingsData.responseReviewedByUser = null;
    this.findingsData.implementationReviewedByUser = null;
    this.findingsData.isCapaRequired = false;
    this.findingsData.capaNo = null;
    this.selectedSeverity = null;
    this.selectedAssignedToUser = null;
    this.selectedAssignedToDepartment = null;
    this.isSeverityOdd = null;
    this.isassignedToDepartmentOdd = null;
    this.isassignedToUserOdd = null;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  editingFindingId: any;
  event = {
    isUserInput: true,
    source: {
      _selected: true,
    }
  };

  isRequestedAtOdd: any = null;
  openEditPopup(auFindingsEditingData: any) {
    this.buttonList = [];
    this.isProcessing = true;
    this.operationFlag = 'EDIT';
    this.popupTitle = "Update Audit Findings";
    this.visibleEditButton = false;
    this.editingFindingId = auFindingsEditingData.FINDING_ID;
    this.appService.getAuFindingByFindingId(this.editingFindingId).subscribe((data: any) => {

      this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y' && this.onRequestedAtSelect(this.event, { valueExp: data.requestedAt, displayExp: data.requestedAt });

      data.expectedClosureDate = data.expectedClosureDate ? new Date(data.expectedClosureDate) : null;
      data.expectedCaClosureDate = data.expectedCaClosureDate ? new Date(data.expectedCaClosureDate) : null;
      data.expectedPaClosureDate = data.expectedPaClosureDate ? new Date(data.expectedPaClosureDate) : null;
      data.dueDate = data.dueDate ? new Date(data.dueDate) : null;
      data.lastReminderSentOn = data.lastReminderSentOn ? new Date(data.lastReminderSentOn) : null;
      data.isApplicationUser = data.isApplicationUser == "Y";
      data.isCapaRequired = data.isCapaRequired == "Y";

      if (data.severity) {
        const filteredSeverityValue = this.severityDropdown.find((item: any) => item.valueExp == data.severity);
        if (filteredSeverityValue) {
          this.selectedSeverity = filteredSeverityValue.codelistCode;
          this.isSeverityOdd = null;
        } else {
          this.severityDropdown.push({
            valueExp: data.severity,
            displayExp: data.severity
          });
          this.isSeverityOdd = this.selectedSeverity = data.severity;
        }
      }
      if (data.responseReviewedByUser) {
        const filteredresponseReviewValue = this.responseReviewDropdown.find((item: any) => item.userId == data.responseReviewedByUser);
        if (filteredresponseReviewValue) {
          this.selectedResponseReviewUser = filteredresponseReviewValue.userId;
        }
      }
      if (data.implementationReviewedByUser) {
        const filteredimplementationReviewedValue = this.implementationReviewerDropdown.find((item: any) => item.userId == data.implementationReviewedByUser);
        if (filteredimplementationReviewedValue) {
          this.selectedResponseReviewUser = filteredimplementationReviewedValue.userId;
        }
      }

      this.appService.getAuParticipantsByAuNo(auFindingsEditingData.AU_NO).subscribe((data: any) => {
        this.dropDownForAssignedToUser = data;
        if (data.responsibilityUser) {
          const filteredResponsibilityUserValue = this.assignedToUserDropDown.find((item: any) => item.valueExp == data.responsibilityUser);
          if (filteredResponsibilityUserValue) {
            this.selectedAssignedToUser = filteredResponsibilityUserValue.applicationUserId;
            this.isassignedToUserOdd = null;
          } else {
            this.assignedToUserDropDown.push({
              valueExp: data.responsibilityUser,
              displayExp: data.responsibilityUser
            })
            this.isassignedToUserOdd = this.selectedAssignedToUser = data.responsibilityUser;
          }
        }
        this.selectBoxForResponsibilityUserList();
        this.isProcessing = false;
      });

      this.findingsData = data;
      this.buttongetCall();
      this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    })
  }

  deletingFindingId: any;
  openDeletePopup(auFindingsEditingData: any) {
    this.operationFlag = 'DELETE';
    this.popupTitle = "Delete Audit Findings";
    this.deletingFindingId = auFindingsEditingData.FINDING_ID;
    this.findingsData.deleteReason = '';
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  findingFieldValue: any;
  referencesFieldValue: any;
  fieldValidation() {
    this.findingFieldValue = document.getElementById('finding-validation') as HTMLInputElement;
    this.referencesFieldValue = document.getElementById('reference-validation') as HTMLInputElement;

    if (this.findingsData.finding == '' || this.findingsData.finding == undefined) {
      this.findingFieldValue.style.color = 'red';
    } else {
      this.findingFieldValue.style.color = '#005c8a';
    }

    if (this.findingsData.reference == '' || this.findingsData.reference == undefined) {
      this.referencesFieldValue.style.color = 'red';
    } else {
      this.referencesFieldValue.style.color = '#005c8a';
    }
  }

  onFieldFocusout(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  handleDropDownValidation(fieldId: string, selectedItems: any) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = selectedItems == null && field ? 'red' : '#005c8a';
  }

  async validateAudit(): Promise<void> {
    const validations = [
      { condition: this.isContentEmpty(this.findingsData.finding), id: 'finding-validation' },
      { condition: (this.dynamicLabel['REFERENCE']?.isRemovable != 'Y' && this.isContentEmpty(this.findingsData.reference)), id: 'reference-validation' },
      { condition: this.selectedSeverity == null, id: 'severity-validation' },
      { condition: this.selectedAssignedToUser == null, id: 'assign-to-user-validation' },
      { condition: !this.findingsData.findingShortDescription, id: 'finding-short-description-validation' },
      { condition: !this.findingsData.capaDetails && this.findingsData.isCapaRequired, id: 'capaActivity-validation' },
      { condition: (this.businessAreaDropdown.length ? !this.selectedBusinessArea.length : !this.findingsData.coreBusinessAreaName) && this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y' && this.findingsData.requestedAt, id: 'business-area' },

    ]
    await this.handleAsyncValidation(validations);
  }

  private async handleAsyncValidation(validations: { condition: boolean, id: string }[]): Promise<void> {
    const invalidIds: string[] = validations.filter(v => v.condition).map(v => v.id);
    this.validatedFindingArray.push(invalidIds.length > 0 ? 'Failed' : 'Passed')
    if (invalidIds.length > 0) {
      this.manageValidations(invalidIds);
    }
  }

  manageValidations(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    })
  }

  validatedFindingArray: any = [];
  // Utility to check if HTML content is empty (ignores tags like <br>, <p></p>, etc.)
  isContentEmpty(content: string): boolean {
    if (content == null || content === undefined) return true;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;
    const textContent = (tempDiv.textContent ?? tempDiv.innerText) || '';
    return textContent.trim().length === 0;
  }
  addAndEditFunction(findingsData: any) {
    return new Promise<boolean>((resolve) => {
      let validationPromises: Promise<void>[] = [];
      this.validatedFindingArray = [];
      validationPromises.push(this.validateAudit());
      Promise.all(validationPromises)
        .then(() => {
          const isValid = !this.validatedFindingArray.includes('Failed');
          if (isValid) {
            this.isProcessing = true;
            if (findingsData.expectedClosureDate) {
              const expectedClosureDateValue = new Date(findingsData.expectedClosureDate);
              findingsData.expectedClosureDate = this.appService.dateZoneConvertion(expectedClosureDateValue);
            } else {
              findingsData.expectedClosureDate = null;
            }

            // Ensure empty HTML fields are sent as null
            if (!findingsData.reference || this.isContentEmpty(findingsData.reference)) {
              findingsData.reference = null;
            }
            if (!findingsData.finding || this.isContentEmpty(findingsData.finding)) {
              findingsData.finding = null;
            }
            if (!findingsData.auditorComments || this.isContentEmpty(findingsData.auditorComments)) {
              findingsData.auditorComments = null;
            }
            if (!findingsData.assignedToUserDetails || this.isContentEmpty(findingsData.assignedToUserDetails)) {
              findingsData.assignedToUserDetails = null;
            }
            if (!findingsData.deliverables || this.isContentEmpty(findingsData.deliverables)) {
              findingsData.deliverables = null;
            }

            let businessArea = null;
            if (this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y') {
              businessArea = this.businessAreaDropdown.length ? this.selectedBusinessArea?.join(',') : this.findingsData?.coreBusinessAreaName ?? null;
            }

            let data = {
              auNo: this.message.activityId,
              seq: findingsData.seq,
              findingShortDescription: findingsData.findingShortDescription,
              finding: findingsData.finding,
              reference: findingsData.reference,
              severity: this.selectedSeverity ?? null,
              auditorComments: findingsData.auditorComments,
              expectedClosureDate: findingsData.expectedClosureDate,
              deliverables: findingsData.deliverables,
              assignedToUser: this.selectedAssignedToUser ?? null,
              responseReviewedByUser: null,
              implementationReviewedByUser: null,
              assignedToDepartment: this.selectedAssignedToDepartment ?? null,
              assignedToUserDetails: findingsData.assignedToUserDetails,
              isCapaRequired: findingsData.isCapaRequired ? "Y" : "N",
              capaNo: findingsData.isCapaRequired ? findingsData.capaNo : null,
              requestedAt: this.dynamicLabel['REQUESTED_AT']?.isRemovable == 'Y' ? null : findingsData.requestedAt,
              coreBusinessAreaName: this.dynamicLabel['REQUESTED_AT']?.isRemovable == 'Y' ? null : businessArea,
            }
            if (this.selectedResponseReviewUser != undefined) {
              if (this.findingsData.responseReviewedByUser == 0) {
                data.responseReviewedByUser = this.findingsData.responseReviewedByUser;
              } else if (this.selectedResponseReviewUser) {
                data.responseReviewedByUser = this.selectedResponseReviewUser;
              }
            }
            if (this.selectedImplementationReviewerUser != undefined) {
              if (this.findingsData.implementationReviewedByUser == 0) {
                data.implementationReviewedByUser = this.findingsData.implementationReviewedByUser;
              } else if (this.selectedImplementationReviewerUser) {
                data.implementationReviewedByUser = this.selectedImplementationReviewerUser;
              }
            }
            if (this.operationFlag == 'ADD') {
              this.appService.createAuFinding(data).subscribe({
                next: (Response: any) => {
                  if (Response.resultType == "S") {
                    this.ngOnInit();
                    this.visibleAddAndEditPopup.close();
                    this.showSnackBar(Response.result, Response.resultType);
                  } else {
                    this.showSnackBar(Response.result, Response.resultType);
                    this.isProcessing = false;
                  }
                },
                error: (error) => {
                  this.isProcessing = false;
                  throw error;
                }
              });
            } else {
              delete findingsData.createdOn;
              delete findingsData.updatedOn;
              const modifiedData = {
                ...data,
                findingId: this.editingFindingId
              }
              this.appService.updateAuFinding(modifiedData).subscribe({
                next: (Response: any) => {
                  if (Response.resultType == "S") {
                    this.ngOnInit();
                    this.visibleAddAndEditPopup.close();
                    this.showSnackBar(Response.result, Response.resultType);
                  } else {
                    this.showSnackBar(Response.result, Response.resultType);
                    this.isProcessing = false;
                  }
                },
                error: (error) => {
                  this.isProcessing = false;
                  throw error;
                }
              });
            }
          } else {
            this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
          }
        }).catch((error) => {
          console.error('Error occurred during validation:', error);
          resolve(false);
        })
    })
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteReasonfieldValidation: any;
  deleteFunction(findingsData: any) {
    if (this.findingsData.deleteReason) {
      this.isProcessing = true;
      const data = {
        auNo: this.message.activityId,
        findingId: this.deletingFindingId,
        deleteReason: findingsData.deleteReason
      }
      this.appService.deleteAuFinding(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.ngOnInit();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      this.deleteReasonfieldValidation = document.getElementById('delete-reason-validation') as HTMLInputElement;
      this.deleteReasonfieldValidation.style.color = 'red';
      alert('Please enter the all mandatory fields...');
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  //finding dynamic btn
  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  isEsignRequired: boolean;
  isReasonSignReqd: boolean;
  buttonLabel: any;
  reason: any;
  userName: any;
  password: any = "";
  reviewStatus: any;
  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  selectedStatus: any = null;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;

  visibleValidationConfirm: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmValidationPopup', { static: true }) confirmValidationPopup: TemplateRef<any>;
  confirmValidationPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  confirmValidationOkFunc() {
    this.visibleValidationConfirm.close();
  };

  buttonList: any;
  buttongetCall() {
    this.buttonList = [];
    const getbuttons = {
      findingId: this.findingsData.findingId,

    }
    this.appService.getFindingsButtons(getbuttons).subscribe((data: any) => {
      if (data.labelsResult) {
        data.labelsResult = data.labelsResult + ",Cancel";
        this.buttonList = data.labelsResult.split(",");
      } else {
        data.labelsResult = "Cancel";
        this.buttonList = data.labelsResult.split(",");
      }
    });
  }

  cancelValidationConfirmFunc() {
    this.visibleValidationConfirm.close();
  };

  dynamicButtonClick(button: any) {
    this.buttonLabel = button;
    if (button == "") {
      this.findingsData.FINDING_ID = this.findingsData.findingId;
      this.openDeletePopup(this.findingsData);
    } else {
      if (button == "Review") {
        this.reviewStatus = ['Reviewed', 'Review Rejected'];
      } else if (button == "Approve") {
        this.reviewStatus = ['Approved', 'Approval Rejected'];
      } else if (button == "Verify Response") {
        this.reviewStatus = ['Response Verified', 'Response Verification Rejected'];
      } else if (button == "Verify Implementation") {
        this.reviewStatus = ['Implementation Verified', 'Implementation Verification Rejected'];
      }
      this.selectedStatus = null;
      this.reason = "";
      this.password = "";
      this.userName = localStorage.getItem("loggedUserName");
      this.isEsignRequired = false;
      this.isReasonSignReqd = true;
      this.isEsignRequired = true;
      this.changetypeAddAndEditPassword = false;
      this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
    }
  }

  onPasswordFieldFocusout() {
    if (this.passwordFieldValue != undefined) {
      if (this.password == '' || this.password == undefined || this.password == null) {
        this.passwordFieldValue.style.color = 'red';
      } else {
        this.passwordFieldValue.style.color = '#005c8a';
      }
    }
  }

  passwordFieldValue: any;
  reviewUserFieldValue: any;
  approverUserFieldValue: any;
  reviewAndapproveToggleValue: any;
  reasonFieldValue: any;
  dynamicButtonFieldValidation() {
    this.passwordFieldValue = document.getElementById('password-validation') as HTMLInputElement;
    this.reviewUserFieldValue = document.getElementById('reviewUser-validation') as HTMLInputElement;
    this.approverUserFieldValue = document.getElementById('approverUser-validation') as HTMLInputElement;
    this.reviewAndapproveToggleValue = document.getElementById('reviewAndapprove-validation') as HTMLInputElement;
    this.reasonFieldValue = document.getElementById('reason-validation') as HTMLInputElement;

    if (this.password == '' || this.password == undefined || this.password == null) {
      this.passwordFieldValue.style.color = 'red';
    } else {
      this.passwordFieldValue.style.color = '#005c8a';
    }

    if (this.buttonLabel == "Review" || this.buttonLabel == "Approve" ||
      this.buttonLabel == 'Verify Response' || this.buttonLabel === 'Verify Implementation') {
      if (this.selectedStatus == null) {
        this.reviewAndapproveToggleValue.style.color = 'red';
      } else {
        this.reviewAndapproveToggleValue.style.color = '#005c8a';
      }
      if (this.reason == '' || this.reason == undefined || this.reason == null) {
        this.reasonFieldValue.style.color = 'red';
      } else {
        this.reasonFieldValue.style.color = '#005c8a';
      }
    }
  }

  radioChange(event: any) {
    if (this.reviewAndapproveToggleValue != undefined) {
      this.reviewAndapproveToggleValue.style.color = '#005c8a';
    }
  }

  getColor(status: any) {
    if (status.includes('Rejected') || status.includes('Deleted') || status.includes('Obsoleted')) {
      return 'red';
    } else if (status.includes('Open') || status.includes('Draft') || status.includes('Scheduled') || status.includes('Initiated')) {
      return 'orange';
    } else if (status.includes('Closed') || status.includes('Completed') || status.includes('Approved')) {
      return 'green';
    } else {
      return '#005c8a';
    }
  }

  confirmWithReasonFunc() {
    this.isProcessing = true;
    if (this.password == '' ||
      ((this.buttonLabel == 'Review' || this.buttonLabel == 'Approve' || this.buttonLabel == 'Reject Response' ||
        this.buttonLabel == 'Accept Response' || this.buttonLabel == 'Reject Implementation' ||
        this.buttonLabel == 'Accept Implementation' || this.buttonLabel == 'verify Response' || this.buttonLabel === 'verify implementation')
        && (this.reason == "" || this.reason == null))) {
      this.dynamicButtonFieldValidation();
      alert('Please enter the all mandatory fields...');
      this.isProcessing = false;
    } else {
      let selectedStatus
      if (this.buttonLabel == "Review" || this.buttonLabel == "Approve" || this.buttonLabel == 'verify Response' || this.buttonLabel === 'verify implementation') {
        selectedStatus = this.selectedStatus
      } else {
        selectedStatus = this.buttonLabel
      }
      this.isProcessing = true;
      let data = {
        findingId: this.findingsData.findingId,
        currentStatus: this.findingsData.status,
        buttonOperation: selectedStatus,
        comments: this.reason,
      }
      this.appService.performFindingsAction(data).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == "S") {
          this.buttongetCall();
          this.getcallMethod();
          this.visibleConfirmWithReason.close();
          this.isProcessing = true;
        }
        this.showSnackBar(Response.result, Response.resultType);
        this.isProcessing = false;
      })
    }
  }

  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }

  //CAPA
  onIsCapaRequiredChecked(event: any) {
    if (!event.checked) {
      this.findingsData.capaNo = null;
    }
  }

  showUserSearchGrid: boolean;
  searchByDepartmentCode: any = [];
  findingInfo: any;

  openSearchCapaRequiredPopup() {
    this.qmsservice.isCapaTriggeredFromFindingPage = true;
    this.selectedCapaGroup = null;
    this.searchByDepartmentCode = null;
    this.showUserSearchGrid = true;
    this.qmsservice.auFindings = true;
    this.popupTitle = "CAPA";
    this.qmsservice.tempactivitybuttonDetails = this.qmsservice.activity;
    this.qmsservice.tempselectedGroupDetailId = this.qmsservice.selectedGroupDetailId;
    if (this.findingsData.finding) {
      this.qmsservice.findingDetailsForCapaDescription = this.findingsData.finding;
    } else {
      this.qmsservice.findingDetailsForCapaDescription = '';
    }
    this.findingInfo = this.qmsservice.activity.auId + ' : ' + this.findingsData.finding;
    this.mapCapa();
  }

  @ViewChild(AddMapCapaComponent) addMapCapaComponent!: AddMapCapaComponent;
  mapCapa() {
    this.message.isFromFindings = true;
    this.addMapCapaComponent.openPopup();
  }

  onCapaEmitted() {
    const capa = this.message.addMapCapaFindings;
    if (capa) {
      this.findingsData.capaDetails = capa.capaId + '(' + capa.status + ')';
      this.findingsData.capaNo = capa.capaNo;
    }
    this.isProcessing = false;
  }


  unmapCapa() {
    this.findingsData.capaDetails = null;
  }
  selectedTabName: any;
  onTabClick(event: any) {
    if (event.tab.textLabel == "Map CAPA") {
      this.showUserSearchGrid = false;
      this.selectedTabName = event.tab.textLabel;
    } else {
      this.selectedCapaGroup = null;
      this.searchByDepartmentCode = null;
      this.showUserSearchGrid = true;
      this.selectedTabName = event.tab.textLabel;
    }
  }

  cancelSearchCapaRequiredPopup() {
    this.qmsservice.moduleName = "AU";
    this.qmsservice.activity = this.qmsservice.tempactivitybuttonDetails;
    if (this.operationFlag == 'ADD') {
      this.popupTitle = this.popupTitle == "CAPA" ? "Create Audit Findings" : "";
    } else {
      this.popupTitle = this.popupTitle == "CAPA" ? "Update Audit Findings" : "";
    }
    this.visibleSearchCapaRequiredPopup.close();
  }

  detailsData(data: any, idx: any) {
    if (idx == 0) {
      this.auService.findingId = data.FINDING_ID;
      this.auService.findingsData = data;
      this.router.navigate(['dashboard/auFindingDetails'], { state: { finding: data } });
    }
  }

  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  closeMandatoryPopup() {
    this.visibleMandatoryPopup.close();
  }

  makeStickyColumns: any;
  auFindingsDataForGrid: any = [];
  auFindingsDataForGridTemp: any = [];
  getQmsCapaVwDetailsData: any = [];
  columnLists: any = {};
  dataTypeList: any = [];
  searchText: any;
  searchValue: any;
  showingRowsText = "Showing rows";
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  pager: any = {};
  pagedItems: any[];
  dateCustomClasses: DatepickerDateCustomClasses[];

  getcallMethod() {
    this.isProcessing = true;
    const data = {

      gridName: "AU_FINDINGS",
      groupId: null
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "QMS_AU_FINDINGS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          auNoFromAu: this.message.activityId,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        };

        this.reportObj = { ...data1, ...data };

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {

            this.auFindingsDataForGrid = response1;
            this.visibleAuditTrail = false;
            this.qmsservice.auFindingsList = response1;

            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];

            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              });
            }

            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];

            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }

            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };

            this.columnLists.columnsListarray1 = [];

            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {

                this.dataTypeList = response2;

                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;

                  for (const element of this.dataTypeList) {
                    if (element.columnName == this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                    }
                  }
                }

                for (const row of this.auFindingsDataForGrid) {
                  for (const element of this.dataTypeList) {
                    if (element.fieldType == 'CHECKBOX') {
                      row[element.columnName] = row[element.columnName] == "Y";
                    }
                  }
                }

                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.labelcall();
                this.setPage(1, 0);

              }
            });

            this.message.gridList = this.auFindingsDataForGrid;
            this.collectionSize = this.auFindingsDataForGrid.length;
            this.totalPages = Math.ceil(this.auFindingsDataForGrid.length / this.itemsPerPage);
            this.isProcessing = false;

          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });

        this.isProcessing = false;

      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.dynamicLabel = null;
    this.label = [];
    this.dynamicLabel = null;
    let data = {
      gridName: this.reportObj.gridName,
      tableName: this.reportObj.tableOrViewName,
      moduleName: this.qmsservice.moduleName,
      groupId: this.qmsservice.selectedGroup,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.auFindingsDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.auFindingsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.isProcessing = false;
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.auFindingsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.auFindingsDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }


  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.auFindingsDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.auFindingsDataForGridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.auFindingsDataForGridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.auFindingsDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.auFindingsDataForGridTemp = this.auFindingsDataForGrid;
      this.pager = this.paginationService.getPager(this.auFindingsDataForGridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.auFindingsDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.auFindingsDataForGrid == undefined) {
        return this.auFindingsDataForGrid;
      }
      if (!this.auFindingsDataForGrid.length) {
        return this.auFindingsDataForGrid;
      }
      if (filter) {
        this.auFindingsDataForGridTemp = this.auFindingsDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.auFindingsDataForGridTemp = this.auFindingsDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 150;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 150;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.auFindingsDataForGrid) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.auFindingsDataForGrid) {
        element.childCheckBoxs = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.auFindingsDataForGrid[this.previousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.FINDING_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.auFindingsDataForGrid.some((list: any) => list.childCheckBoxs);
    this.previousSelectedValue = idx;
  }

  refreshGridData() {
    this.getcallMethod();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, finding: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : finding.FINDING_ID;
    this.auditTrail.activityRefNo = this.message.activityId;
    this.auditTrail.gridName = 'AU_FINDINGS';
    this.auditTrail.report_And_Popup_Name = 'Finding Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(finding);
  }
  @ViewChild('viwerClobPopup', { static: true }) viwerClobPopup: TemplateRef<any>;
  visibleviwerClobPopup: MatDialogRef<TemplateRef<any>>;
  aviwerlPopupConfig = {
    width: '80%',
    height: '80%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  }

  @ViewChild('clobViewPopup', { static: false }) clobViewPopupComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: 'QMS_AU_FINDINGS_VW',
      columnName: colunName
    }
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        const content = Response.result;

        this.isProcessing = false;

        if (this.clobViewPopupComponent) {
          this.clobViewPopupComponent.openEditor(content, colunName);
          console.error("Editor component reference (#clobViewPopup) not found. Ensure the template is rendered and ViewChild is correctly configured.");
        }
      },
      error: (error) => {
        console.log(error);
        this.isProcessing = false;
      }
    });
  }

  htmlContent: any;
  closeHtmlContent() {
    this.visibleviwerClobPopup.close();
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qmsservice.moduleName + ' Findings Report [' + this.qmsservice.activity.auId + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  snackbarRef: any;
  ngAfterViewInit() {
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }


  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, this.qmsservice.moduleName, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };
  onChildValueEmitted1() {
    this.cancelSearchCapaRequiredPopup();
  };
  removeHtmlTags(html: string) {
    if (typeof html !== 'string') return html;
    return html.replaceAll(/<[^>]+>/g, '');
  }

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }

  onIsCAPARequiredChange(e: any) {
    this.findingsData.capaDetails = this.findingsData.capaNo = null;
  }

  @ViewChild('reorderGridPopup', { static: true }) reorderGridPopup!: TemplateRef<any>;
  visibleReorderGridPopup!: MatDialogRef<any>;

  grid: any[] = [];
  isReordered: boolean = false;

  reorderPopupConfig = {
    width: '750px',
    maxHeight: '85vh',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '20px' }
  };

  openReorderPopup(): void {
    this.grid = [...this.pagedItems];

    this.grid.sort((a, b) => (a.SEQ || 0) - (b.SEQ || 0));

    this.grid.forEach((row: any, index: number) => {
      row.NEW_ORDER = row.SEQ ?? index + 1;
    });

    this.isReordered = false;

    this.visibleReorderGridPopup = this.dialog.open(
      this.reorderGridPopup,
      this.reorderPopupConfig
    );
  }

  dragAndDrop(event: any): void {
    moveItemInArray(this.grid, event.previousIndex, event.currentIndex);

    this.grid.forEach((row: any, index: number) => {
      row.NEW_ORDER = index + 1;
    });

    this.isReordered = true;
  }

  reorderFindings(): void {
    if (!this.isReordered) {
      this.visibleReorderGridPopup.close();
      return;
    }

    this.isProcessing = true;
    let completed = 0;
    const total = this.grid.length;

    this.grid.forEach((row: any) => {
      this.appService.getAuFindingByFindingId(
        row.FINDING_ID
      ).subscribe((fullData: any) => {

        fullData.findingSlNo = row.NEW_ORDER;
        fullData.auNo = this.message.activityId;

        this.normalizeClobPayload(fullData);

        this.appService.updateAuFinding(fullData).subscribe({
          next: () => {
            completed++;
            if (completed === total) this.finishReorder();
          },
          error: () => {
            completed++;
            if (completed === total) this.finishReorder();
          }
        });
      });
    });
  }

  private normalizeClobPayload(obj: any): void {
    const clobFields = [
      'finding',
      'reference',
      'deliverables',
      'auditorComments',
      'assignedToUserDetails'
    ];

    clobFields.forEach(field => {
      if (obj[field] !== null && typeof obj[field] === 'string') {
        const cleaned = obj[field].replaceAll(/<[^>]*>/g, '').trim();
        if (!cleaned) obj[field] = null;
      }
    });
  }

  private finishReorder(): void {
    this.isProcessing = false;
    this.visibleReorderGridPopup.close();
    this.refreshGridData();
    this.isReordered = false;
    this.showSnackBar('Findings reordered successfully', 'S');
  }

  cancelReorder(): void {
    this.visibleReorderGridPopup.close();
  }

  reorderActions(): void {
    if (!this.isReordered || !this.grid?.length) return;

    this.isProcessing = true;

    const tasks = this.grid.map(async (row: any) => {

      const fullData: any = await firstValueFrom(
        this.appService.getAuFindingByFindingId(
          row.FINDING_ID
        )
      );

      const payload: any = {
        auNo: this.message.activityId,
        findingId: fullData.findingId,
        seq: row.NEW_ORDER,
        findingShortDescription: fullData.findingShortDescription,
        finding: this.cleanClob(fullData.finding),
        reference: this.cleanClob(fullData.reference),
        deliverables: this.cleanClob(fullData.deliverables),
        additionalDetails: fullData.additionalDetails,
        severity: fullData.severity,
        auditorComments: this.cleanClob(fullData.auditorComments),
        additionalField: fullData.additionalField,
        rootCauseAnalysis: this.cleanClob(fullData.rootCauseAnalysis),
        immediateCorrection: this.cleanClob(fullData.immediateCorrection),
        correctiveAction: this.cleanClob(fullData.correctiveAction),
        preventiveAction: this.cleanClob(fullData.preventiveAction),
        expectedCaClosureDate: fullData.expectedCaClosureDate ? this.appService.dateZoneConvertion(new Date(fullData.expectedCaClosureDate)) : null,
        expectedPaClosureDate: fullData.expectedPaClosureDate ? this.appService.dateZoneConvertion(new Date(fullData.expectedPaClosureDate)) : null,
        comments: fullData.comments ?? null,
        assignedToUser: fullData.assignedToUser,
        assignedToDepartment: fullData.assignedToDepartment,
        expectedClosureDate: fullData.expectedClosureDate
          ? this.appService.dateZoneConvertion(new Date(fullData.expectedClosureDate))
          : null,
        isCapaRequired: fullData.isCapaRequired,
        capaNo: fullData.isCapaRequired ? fullData.capaNo : null,
        dueDate: fullData.dueDate ? this.appService.dateZoneConvertion(new Date(fullData.dueDate)) : null,
        closureComments: fullData.closureComments ?? null,
        assignedToUserDetails: this.cleanClob(fullData.assignedToUserDetails),
        responseReviewedByUser: fullData.responseReviewedByUser,
        implementationReviewedByUser: fullData.implementationReviewedByUser,
        actualClosedDate: fullData.actualClosedDate,
        requestedAt: fullData.requestedAt,
        coreBusinessAreaName: fullData.coreBusinessAreaName,
      };

      await firstValueFrom(this.appService.updateAuFinding(payload));
    });

    Promise.all(tasks)
      .then(() => this.finishReorder())
      .catch(() => this.finishReorder());
  }

  private cleanClob(clob: string): string | null {
    if (!clob) return null;
    const cleaned = clob.replaceAll(/<[^>]+>/g, '').trim();
    return cleaned.length ? clob : null;
  }

  public focusEmpty(): void {
    console.log();
  }

}
